export default __webpack_public_path__ + "static/media/dados_basicos.6e6ae0bd.svg";